import React, { useCallback, useMemo, useState, useRef } from 'react';
import { Text } from '@beef/ui-kit';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';

import { getCurrentRegionId } from 'store/common/settings/selectors';
import pushEvent, { SHOW_BEELINE_OFFICE_SERVICE, SHOW_RANDOM_SERVICE } from 'pushEvent/index';
import { useIframeMessage } from 'hooks/useIframeMessage';
import { getOriginFromUrl } from 'utils/common';

import style from './SharedZoneNewServices.module.pcss';
import { SharedZoneNewTabs } from '../SharedZoneNewTabs';
import { SHARED_ZONE_NEW } from '../../constants';
import TradeInNewCalculator from '../../components/TradeInNewCalculator';
import { DamProdamIframeEvents } from './contants';

const cx = classNames.bind(style);

const SharedZoneNewServices = ({ calculateSettings, damProdamSettings, frameUrl, isMobile }) => {
  const {
    blockCalculateTitle,
    blockCalculateSubtitle,
    blockCalculateDescription,
    calculateServices,
  } = calculateSettings;

  const [activeService, setActiveServices] = useState(calculateServices?.[0].slug || null);
  const [iframeHeight, setIframeHeight] = useState(0);

  const { enabled, regions } = damProdamSettings;

  const currentRegion = useSelector(getCurrentRegionId);

  const handleClickCalculateService = useCallback((slug) => {
    setActiveServices(slug);
    if (slug === SHARED_ZONE_NEW.BEELINE_OFFICE_SERVICE_SLUG) {
      pushEvent(SHOW_BEELINE_OFFICE_SERVICE);
    }
    if (slug === SHARED_ZONE_NEW.RANSOM_SERVICE_SLUG) {
      pushEvent(SHOW_RANDOM_SERVICE);
    }
  }, []);

  const isActiveRansomService = useMemo(
    () => enabled && regions.includes(currentRegion),
    [enabled, currentRegion, regions],
  );
  const shouldShowCalculator = [
    SHARED_ZONE_NEW.BEELINE_OFFICE_SERVICE_SLUG,
    SHARED_ZONE_NEW.TRADE_IN_SERVICE_SLUG,
  ].includes(activeService);

  const ref = useRef(null);

  useIframeMessage(ref, getOriginFromUrl(frameUrl), (data) => {
    if (data.type === DamProdamIframeEvents.HeightUpdate) {
      setIframeHeight(data.params.height);
    }
  });

  return (
    <div className={cx('wrap')}>
      {!!blockCalculateTitle && (
        <div className={cx('title')}>
          <Text size="size2-m">{blockCalculateTitle}</Text>
        </div>
      )}
      {!!blockCalculateSubtitle && (
        <div className={cx('subtitle')}>
          <Text size="size4-m">{blockCalculateSubtitle}</Text>
        </div>
      )}
      {!!blockCalculateDescription && (
        <div className={cx('description')}>
          <Text size="size5-r-l" color="grey60">
            {blockCalculateDescription}
          </Text>
        </div>
      )}
      {!!calculateServices.length && (
        <SharedZoneNewTabs
          onClick={handleClickCalculateService}
          activeService={activeService}
          calculateServices={calculateServices}
          isActiveRansomService={isActiveRansomService}
        />
      )}
      <div className={cx('calculator')}>
        {shouldShowCalculator && <TradeInNewCalculator />}
        {activeService === SHARED_ZONE_NEW.RANSOM_SERVICE_SLUG && (
          <div
            className={cx('frame', isMobile && 'frameMobile')}
            style={iframeHeight > 0 ? { height: `${iframeHeight}px` } : undefined}
          >
            <iframe
              ref={ref}
              title="Фрейм билайн ДамПродам"
              src={frameUrl}
              width="100%"
              height="100%"
              frameBorder="0"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export { SharedZoneNewServices };
